<template>
  <div class="wrapper">
    <div
      data-aos="zoom-in"
      data-aos-duration="600"
      :data-aos-delay="200 * index"
      class="card-wrap getting-card"
      v-match-heights="{
        el: [
          '.getting-card .card-description',
          '.getting-card .card-text-detail'
        ],
        disabled: [575]
      }"
    >
      <div class="icon-wrap">
        <img :src="item.icon" alt="Complete profile" />
      </div>
      <div class="card-body">
        <div class="card-text-detail">
          <div v-if="!stepDisabled" class="card-step">
            Step 0{{ index + 1 }}
          </div>
          <div class="card-title">
            {{ item.title }}
          </div>
          <div class="card-description">
            <p v-html="item.description" />
          </div>
        </div>
        <div class="card-button" @click="coolboxIndex = 0">
          View Step
        </div>
      </div>
    </div>
    <CoolLightBox
      :items="[item.image]"
      :index="coolboxIndex"
      :effect="'fade'"
      :useZoomBar="true"
      @close="coolboxIndex = null"
    >
    </CoolLightBox>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    },
    stepDisabled: {
      type: Boolean,
      default: false
    }
  },
  // props: ["item", "index"],
  data() {
    return {
      coolboxIndex: null
    };
  }
};
</script>

<style lang="scss">
@import "@/scss/_variable.scss";
.card-wrap {
  background: #ffffff;
  border-radius: 14px;
  overflow: hidden;
  padding: 40px 20px;
  box-shadow: 0 8px 20px 3px rgba(0, 0, 0, 0.13);
  transition: all 0.3s ease-in-out;
  max-width: 350px;
  margin: 0 auto;
  .icon-wrap {
    width: 75px;
    height: 75px;
    margin: 0 auto 30px;
    border-radius: 50%;
    background: $primary-color;
    padding: 20px;
    box-shadow: 0 8px 20px 3px rgba(0, 0, 0, 0.13);

    img {
      filter: brightness(0) invert(1);
    }
  }
  .card-body {
    text-align: center;
    .card-text-detail {
      .card-step {
        font-family: $content-font;
        font-size: 14px;
        line-height: 22px;
        text-transform: uppercase;
        color: #212164;
        font-weight: 600;
        padding-bottom: 5px;
      }
      .card-title {
        font-family: $heading-font;
        font-size: 24px;
        color: $brand-color;
        font-weight: 500;
        margin-bottom: 15px;
      }
      .card-description {
        p {
          font-family: $content-font;
          font-size: 14px;
          line-height: 22px;
          font-weight: 400;
          color: #717171;
        }
      }
    }
    .card-button {
      margin-top: 20px;
      font-family: $content-font;
      text-transform: capitalize;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      color: green;
    }
  }
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 13px 25px 8px rgba(0, 0, 0, 0.23);
  }
}
</style>
